export interface ListItem {
  id: string;

  label: string;
  description?: string;

  value?: string | number;
  quantity?: number;

  readMoreLabel?: string;
  displayReadMore?: boolean;

  image?: string;
  icon?: string;

  disabled?: boolean;

  ariaLabel?: string;
  ariaDescription?: string;
}
